import { render, staticRenderFns } from "./AppAxiosFormFile.vue?vue&type=template&id=13c41462&scoped=true&"
import script from "./AppAxiosFormFile.vue?vue&type=script&lang=js&"
export * from "./AppAxiosFormFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c41462",
  null
  
)

export default component.exports